<template>
    <footer class="terms-of-use-footer">
        <a :href="termsAndCoditionsUrl" target="_blank">
            {{ $t('common.footer_item.terms_conditions') }}
        </a>
        <a :href="privacyPolicyUrl" target="_blank">
            {{ $t('common.footer_item.privacy_policy') }}
        </a>
    </footer>
</template>

<script>
    export default {
        computed: {
            termsAndCoditionsUrl() {
                return `${process.env.VUE_APP_WP_URL}/terms-of-service`
            },
            privacyPolicyUrl() {
                return `${process.env.VUE_APP_WP_URL}/privacy-policy`
            },
        },
    }
</script>
